import { Methods } from "@src/types/api/v1/logs";
import { apiClient } from "@src/api/client";
import { ApiResponse } from "@src/types/api";

export const createLog = async (
  logGroupName: string,
  logInfo: {
    screen_name: string;
    session_id: string;
    operation_type: Methods["post"]["reqBody"]["log_info"]["operation_type"];
    request_info?: Record<string, unknown>;
    response_info?: Record<string, unknown>;
    comment?: string;
    user_agent?: string;
    executed_at: string;
  }
): Promise<ApiResponse<Methods["post"]["resBody"]>> => {
  const response = await apiClient("/v1/logs", {
    method: "POST",
    data: {
      log_group_name: logGroupName,
      log_info: logInfo,
    },
  });
  return response;
};
